module.exports = __webpack_public_path__ + "cadebb39c7ac7dc81dc4197f665ef231.pdf";